(() => {
  'use strict';
  
  // Start - Image Loading
  const SELECTOR = '.img-wrap > img.lazy-img';
  const wired = new WeakSet();

  function wireImage(img) {
    if (!img || wired.has(img)) return;
    const wrap = img.closest('.img-wrap');
    if (!wrap) return;

    wired.add(img);

    function markLoaded() {
      wrap.classList.remove('loading', 'error');
      wrap.classList.add('loaded');
      wrap.setAttribute('aria-busy', 'false');
    }
    function markError() {
      wrap.classList.remove('loading', 'loaded');
      wrap.classList.add('error');
      wrap.setAttribute('aria-busy', 'false');
    }
    function markLoading() {
      wrap.classList.remove('loaded', 'error');
      wrap.classList.add('loading');
      wrap.setAttribute('aria-busy', 'true');
    }

    const onLoad = () => markLoaded();
    const onError = () => markError();

    img.addEventListener('load', onLoad);
    img.addEventListener('error', onError);

    const attrObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && (m.attributeName === 'src' || m.attributeName === 'srcset')) {
          if (!img.complete) markLoading();
        }
      }
    });
    attrObserver.observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });

    if (img.complete) {
      img.naturalWidth ? markLoaded() : markError();
    } else {
      markLoading();
    }

    img.__ajaxImgCleanup__ = () => {
      img.removeEventListener('load', onLoad);
      img.removeEventListener('error', onError);

      attrObserver.disconnect();
      wired.delete(img);

      delete img.__ajaxImgCleanup__;
    };
  }

  function wireInTree(root) {
    if (!(root instanceof Element)) return;

    if (root.matches && root.matches(SELECTOR)) wireImage(root);

    root.querySelectorAll?.(SELECTOR).forEach(wireImage);
  }

  document.querySelectorAll(SELECTOR).forEach(wireImage);

  const domObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach(wireInTree);

      m.removedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches?.(SELECTOR)) node.__ajaxImgCleanup__?.();

        node.querySelectorAll?.(SELECTOR).forEach((img) => img.__ajaxImgCleanup__?.());
      });
    }
  });

  domObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.teardownAjaxImageWatcher = () => {
    domObserver.disconnect();
    document.querySelectorAll(SELECTOR).forEach((img) => img.__ajaxImgCleanup__?.());
  };
  // End - Image Loading

  /* Start - Product Size Guide Button */
  const sizeGuideModal = document.querySelector('.nextdev--product__size-guide-button__modal');

  if (sizeGuideModal != null) {
    const sizeGuideModalCloseButton = sizeGuideModal.querySelector('.nextdev--product__size-guide-button__modal--close');
    const sizeGuideButtons = document.querySelectorAll('.nextdev--product__size-guide-button--cta, a[href="#size-guide"]');

    if (sizeGuideButtons.length > 0) {
      sizeGuideButtons.forEach(sizeGuideButton => {
        sizeGuideButton.addEventListener('click', (e) => {
          e.preventDefault();

          document.body.classList.add('overflow-hidden');
          sizeGuideModal.classList.remove('hide');
        });
      });
    }

    sizeGuideModalCloseButton.addEventListener('click', () => {
      sizeGuideModal.classList.add('hide');
      document.body.classList.remove('overflow-hidden');
    });

    sizeGuideModal.addEventListener('click', (e) => {
      if (e.target == sizeGuideModal) {
        sizeGuideModal.classList.add('hide');
        document.body.classList.remove('overflow-hidden');
      }
    });
  }
  /* End - Product Size Guide Button */

  document.addEventListener('DOMContentLoaded', () => {
    /* Start - Product Media Gallery Review */
    const productMediaGalleryReview = document.querySelector('.nextdev--media-gallery--review');

    if (productMediaGalleryReview != null) {
      const productMediaGalleryReviewCloseButton = productMediaGalleryReview.querySelector('.nextdev--media-gallery--review__close button');

      productMediaGalleryReviewCloseButton.addEventListener('click', (e) => {
        productMediaGalleryReview.classList.add('hide');
      });

      setTimeout(() => {
        productMediaGalleryReview.classList.remove('hide');
      }, 1000);
    }
    /* End - Product Media Gallery Review */

    /* Start - Product Trustpilot Reviews Slider */
    const productTrustpilotReviewsSliderSwiper = document.querySelector('.nextdev--product__trustpilot-reviews-slider .swiper');

    if (productTrustpilotReviewsSliderSwiper != null) {
      new Swiper(productTrustpilotReviewsSliderSwiper, {
        slidesPerView: 1,
        spaceBetween: 24,
        
        mousewheel: {
          forceToAxis: true
        },

        navigation: {
          nextEl: '.nextdev--product__trustpilot-reviews-slider__swiper-button-next',
          prevEl: '.nextdev--product__trustpilot-reviews-slider__swiper-button-prev',
        }
      });
    }
    /* End - Product Trustpilot Reviews Slider */

    /* Start - Product QMax Button */
    const qmaxModal = document.querySelector('.nextdev--product__qmax-modal');

    if (qmaxModal != null) {
      var popup = document.querySelector('[data-qmax-popup]');
      var openBtn = document.querySelector('[data-qmax-open]');
      var closeBtn = document.querySelector('[data-qmax-close]');
    
      function openPopup() {
        popup.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    
      function closePopup() {
        popup.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    
      if (openBtn) openBtn.addEventListener('click', openPopup);
      if (closeBtn) closeBtn.addEventListener('click', closePopup);
    
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.classList.contains('is-open')) {
          closePopup();
        }
      });
    
      var tabs = document.querySelectorAll('[data-qmax-tab]');
      var panels = document.querySelectorAll('[data-qmax-panel]');
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          tabs.forEach(function(t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          var panel = document.querySelector('[data-qmax-panel="' + tab.dataset.qmaxTab + '"]');
          panels.forEach(function(p) {
            p.classList.remove('is-active');
          });
          panel.classList.add('is-active');
        });
      });
    }
    /* End - Product QMax Button */

  });
})();

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
